import React, { useState } from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  Typography, 
  Paper, 
  Tabs, 
  Tab,
  FormControlLabel,
  Checkbox,
  Link,
  CircularProgress,
  Alert
} from '@mui/material';

const Auth = ({ onLogin }) => {
  const [tabValue, setTabValue] = useState(0);
  const [authData, setAuthData] = useState({ 
    email: '', 
    password: '', 
    name: '',
    isDealer: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAuthData({ 
      ...authData, 
      [name]: type === 'checkbox' ? checked : value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const url = tabValue === 0 
        ? 'https://anyworq.com/api/login' 
        : 'https://anyworq.com/api/register';

      const body = tabValue === 0 
        ? { email: authData.email, password: authData.password } 
        : { name: authData.name, email: authData.email, password: authData.password, isDealer: authData.isDealer };

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Authentication failed');
      
      onLogin(data);
      localStorage.setItem("user", JSON.stringify(data));
// window.location.href = "/user";

    } catch (err) {
      setError(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
minHeight: '86vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url('/images/loginbg.png')`, // ✅ path to your image
    backgroundSize: 'cover',   // make it cover the whole area
    backgroundPosition: 'center', // center the image
    backgroundRepeat: 'no-repeat', // avoid tiling
    position: 'relative',
    overflow: 'hidden',
      }}
    >
      {/* AI-inspired background patterns */}
      <Box
        sx={{
          position: 'absolute',
          width: '700px',
          height: '700px',
          background: 'radial-gradient(circle, rgba(0,196,167,0.3) 0%, transparent 70%)',
          top: '-200px',
          right: '-200px',
          borderRadius: '50%',
          filter: 'blur(100px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: '500px',
          height: '500px',
          background: 'radial-gradient(circle, rgba(50,78,110,0.3) 0%, transparent 70%)',
          bottom: '-150px',
          left: '-150px',
          borderRadius: '50%',
          filter: 'blur(100px)',
        }}
      />

      {/* Auth Card */}
      <Paper
        elevation={6}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 420,
          borderRadius: '20px',
          backdropFilter: 'blur(10px)',
          background: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.15)',
          color: '#fff',
        }}
      >
        {/* <img src="/logo.png" alt="anyworq logo" style={{ width: 120, marginBottom: 20 }} loading="lazy" /> */}
        <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 600, fontFamily: `'Segoe UI', SegoeUI, "Helvetica Neue", Helvetica, Arial, sans-serif'`, color: '#000' }}>
          {tabValue === 0 ? 'Welcome Back!' : 'Create Your Account'}
        </Typography>
        {/* <Tabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
          centered
          textColor="inherit"
          TabIndicatorProps={{ style: { backgroundColor: '#00C4A7' } }}
        >
          <Tab label="Login" sx={{ color: '#fff', fontWeight: 600 }} />
          <Tab label="Sign Up" sx={{ color: '#fff', fontWeight: 600 }} />
        </Tabs> */}
        
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          {tabValue === 1 && (
            <>
              <TextField
              className="small-input"
                fullWidth
                label="Full Name"
                name="name"
                value={authData.name}
                onChange={handleChange}
                margin="normal"
                required
                InputLabelProps={{ style: { color: '#ddd' } }}
                InputProps={{ style: { color: '#000' } }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="isDealer"
                    checked={authData.isDealer}
                    onChange={handleChange}
                    sx={{ color: '#00C4A7' }}
                  />
                }
                label="I'm a service provider/dealer"
                sx={{ color: '#ddd' }}
              />
            </>
          )}
          
          <TextField
          className="small-input"
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={authData.email}
            onChange={handleChange}
            margin="normal"
            required
            InputLabelProps={{ style: { color: '#ddd' } }}
            InputProps={{ style: { color: '#000' } }}
          />
          
          <TextField
          className="small-input"
            fullWidth
            label="Password"
            name="password"
            type="password"
            value={authData.password}
            onChange={handleChange}
            margin="normal"
            required
            inputProps={{ minLength: 6 }}
            InputLabelProps={{ style: { color: '#ddd' } }}
            InputProps={{ style: { color: '#000' } }}
          />
          
          <Box sx={{ mt: 2, mb: 2 }}>
            <Link href="#" variant="body2" sx={{ color: '#00C4A7' }}>
              Forgot password?
            </Link>
          </Box>
          
          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            sx={{
              mt: 1, mb: 2,
              background: 'linear-gradient(90deg, #00C4A7, #324E6E)',
              borderRadius: '30px',
              textTransform: 'none',
              fontWeight: 600,
              '&:hover': {
                background: 'linear-gradient(90deg, #00E0BF, #3E5C82)',
              }
            }}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              tabValue === 0 ? 'Login' : 'Sign Up'
            )}
          </Button>
        </form>
        
        {tabValue === 0 ? (
          <Typography variant="body2" align="center" sx={{ color: '#bbb' }}>
            Don't have an account?{' '}
            <Link href="#" onClick={() => setTabValue(1)} sx={{ color: '#00C4A7' }}>
              Sign up
            </Link>
          </Typography>
        ) : <Typography variant="body1" align="center" sx={{ color: '#bbb' }}>
            Already have an account?{' '}
            <Link href="#" onClick={() => setTabValue(0)} sx={{ color: '#00C4A7' }}>
              Login
            </Link>
          </Typography>}
      </Paper>
    </Box>
  );
};

export default Auth;
